import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import axios from 'axios';
import { imageBaseURL } from '../../actions/Base_URL';
import nareshImg from '../../assets/team/naresh.jpg';
import IPDLogo from '../../assets/team/nvcti_logo.jpg';
import { Base_URL, userEndpoint } from '../../actions/API_endpoint';

const NVCTICompleteSection = () => {
    const [aboutImageUrl, setAboutImageUrl] = useState(IPDLogo);
    const [headMember, setHeadMember] = useState(null);

    const facilities = [
        "Electronics & IoT Facilities",
        "Advanced Rapid Prototyping",
        "Industry Robotics & Automation",
        "Battery Manufacturing Unit",
        "AR/VR Gaming & Animation"
    ];

    useEffect(() => {
        const fetchAboutImage = async () => {
            try {
                const response = await axios.get(`${Base_URL}/api/images/images?type=about-nvcti`);
                let images = [];
                if (response.data && Array.isArray(response.data.images)) {
                    images = response.data.images;
                }
                if (images.length > 0) {
                    const latestImage = images[0];
                    if (latestImage.path) {
                        setAboutImageUrl(`${imageBaseURL}${latestImage.path}`);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch about image:", error);
            }
        };

        const fetchHeadMember = async () => {
            try {
                const response = await axios.get(`${Base_URL}${userEndpoint.getHeadDesk}`);
                if (response.data && response.data.success && response.data.data) {
                    setHeadMember(response.data.data);
                }
            } catch (error) {
                console.error("Failed to fetch head desk:", error);
            }
        };

        fetchAboutImage();
        fetchHeadMember();
    }, []);

    return (
        <div className="bg-dark-secondary min-h-screen py-16 px-4 md:px-8 relative overflow-hidden flex flex-col justify-center">
            {/* Logo at top left, responsive */}


            <div className="max-w-7xl mx-auto w-full pt-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24">
                    {/* About IIT (ISM) Dhanbad */}
                    <div className="flex flex-col items-start space-y-6">
                        <h2 className="text-3xl sm:text-4xl font-bold text-white leading-snug">
                            About NVCTI , IIT (ISM) Dhanbad
                        </h2>
                        <p className="text-gray-300 text-lg leading-relaxed text-justify whitespace-pre-line">
                            The Indian Institute of Technology (Indian School of Mines) Dhanbad established the Naresh Vashisht Centre for Tinkering and Innovation (NVCTI) with the objective of encouraging, inspiring, and nurturing young creators and innovators. The centre aims to provide a supportive environment where students can transform their ideas into real-world products and innovative solutions.

                            NVCTI is located within the Central Research Extensive Building inside the institute campus and spans approximately 11,000 square feet. The facility is designed as a modern, state-of-the-art workspace where students, researchers, and innovators can experiment, prototype, and develop ideas into viable products and entrepreneurial ventures. These facilities provide an enabling environment for young creators to design, build, and test their ideas using advanced tools and technologies.
                        </p>
                    </div>

                    {/* NVCTI Logo Box */}
                    <div className="flex justify-center items-center h-full">
                        <div className="relative p-6 md:p-8 bg-blue-600/20 rounded-3xl border-2 border-blue-400/30 shadow-lg aspect-square flex items-center justify-center w-80 lg:w-[400px]">
                            <img
                                src={aboutImageUrl}
                                alt="NVCTI Logo"
                                className="w-full h-full p-4 bg-white object-contain relative z-10 rounded-2xl"
                            />
                            <div className="absolute inset-0 bg-blue-500/10 blur-3xl rounded-3xl -z-10"></div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Image with Blue Background - Positioned Left */}
                    <div className="flex justify-center items-center h-full">
                        <div className="relative p-6 md:p-8 bg-blue-600/20 rounded-3xl border-2 border-blue-400/30 shadow-lg aspect-square flex items-center justify-center w-full max-w-[280px] sm:max-w-[320px] md:max-w-[360px] lg:max-w-[400px]">
                            <img
                                src={nareshImg}
                                alt="Mr. Naresh Vashisht"
                                className="w-full h-full object-cover relative z-10 rounded-2xl"
                            />
                            <div className="absolute inset-0 bg-blue-500/10 blur-3xl rounded-3xl -z-10"></div>
                        </div>
                    </div>

                    {/* Title and Text - Positioned Right */}
                    <div className="flex flex-col items-start space-y-6">
                        <h2 className="text-3xl sm:text-4xl font-bold text-white leading-snug">
                            About Naresh Vashisht
                        </h2>
                        <p className="text-gray-300 text-lg leading-relaxed text-justify mb-6 whitespace-pre-line">

                            Naresh Vashisht is a distinguished alumnus of Indian Institute of Technology (Indian School of Mines) Dhanbad, belonging to the 1967 batch of Petroleum Engineering. He is a successful entrepreneur and philanthropist who generously supported the establishment of the Naresh Vashisht Centre for Tinkering and Innovation (NVCTI).

                            Through his contribution, the centre was established in September 2019 following the recommendation of the 11th Board of Governors meeting of IIT (ISM) Dhanbad, with the aim of fostering innovation, creativity, and entrepreneurship among students and young innovators.
                        </p>
                        <a
                            href="https://www.ismaana.org/naresh-vashisht-center-for-tinkering-innovation-nvcti/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
                        >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                            </svg>
                            Read about him more
                        </a>
                    </div>

                    {/* Facilities List - Commented Out */}
                    {/* <div className="flex flex-col justify-center space-y-3 md:space-y-4 md:col-span-2 lg:col-span-1">
                        <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2">Our Facilities</h3>
                        {facilities.map((facility, index) => (
                            <div
                                key={index}
                                className="bg-white/10 backdrop-blur-md rounded-lg md:rounded-xl px-4 md:px-6 py-3 md:py-4 flex items-center gap-3 md:gap-4 border border-white/10 hover:bg-white/20 transition-all duration-200"
                            >
                                <div className="w-7 h-7 md:w-8 md:h-8 bg-accent-primary rounded-lg flex items-center justify-center shadow-lg shrink-0">
                                </div>
                                <p className="text-white font-semibold text-sm md:text-base">
                                    {facility}
                                </p>
                            </div>
                        ))}
                    </div> */}
                </div>

                {/* Head's Desk Section - Thin Line Border with Rounded Corners */}
                {headMember && (
                    <div className="mt-20 w-full border border-white/60 p-6 md:p-10 rounded-3xl shadow-2xl">

                        {/* 1. Label and Separator Line */}
                        <div className="mb-10 block border-b border-white/10 pb-6">
                            <h3 className="text-xl md:text-2xl font-bold text-white uppercase tracking-[0.3em] ml-2">
                                {headMember.title || "head desk"}
                            </h3>
                        </div>

                        {/* 2. Main Content & Image (No internal borders) */}
                        <div className="w-full mb-12 flex flex-col md:flex-row items-center md:items-start justify-between gap-12 px-2">
                            {/* Content Area */}
                            <div className="w-full md:w-[68%]">
                                <p className="text-gray-300 text-base md:text-lg leading-relaxed text-left md:text-justify whitespace-pre-line italic">
                                    {headMember.message || "Welcome to the NVCTI at the IIT (ISM), Dhanbad."}
                                </p>
                                <div className="mt-10">
                                    <h4 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-tight">
                                        {headMember.name || "Prof. Alok Kumar Das"}
                                    </h4>
                                    <p className="text-blue-400 font-bold text-sm uppercase tracking-[0.2em] mt-2">
                                        {headMember.designation || "DEAN IIE AND HOC NVCTI"}
                                    </p>
                                </div>
                            </div>

                            {/* Image (No border) */}
                            <div className="w-[200px] h-[200px] md:w-[280px] md:h-[280px] overflow-hidden shrink-0 shadow-2xl">
                                {headMember.image_url ? (
                                    <img
                                        src={`${process.env.REACT_APP_API_URL || Base_URL}/uploads/${headMember.image_url}`}
                                        alt={headMember.name}
                                        className="w-full h-full object-cover grayscale-[5%] hover:grayscale-0 transition-all duration-500"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-blueGray-900 flex items-center justify-center">
                                        <i className="fas fa-user-tie text-6xl text-blueGray-800"></i>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* 3. Contact Box (Separated by top border) */}
                        <div className="w-full flex flex-col md:flex-row items-center justify-between gap-6 px-4 pt-8 border-t border-white/10 mt-8">
                            <div className="flex items-center gap-4">
                                <span className="text-blueGray-400 text-xs uppercase font-bold tracking-[0.2em]">email :</span>
                                <span className="text-white font-bold text-lg md:text-xl tracking-wide select-all">
                                    {headMember.email || "nvcti@iitism.ac.in"}
                                </span>
                            </div>
                            <div className="flex items-center gap-4">
                                <span className="text-blueGray-400 text-xs uppercase font-bold tracking-[0.2em]">phone :</span>
                                <span className="text-white font-bold text-lg md:text-xl tracking-wide select-all">
                                    {headMember.phone || "+91-1234567890"}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NVCTICompleteSection;
